import { getBaseUrl } from '.';

export function getClientOnboardingUrl(advisorId: string): string {
  const baseUrl = getBaseUrl();
  return `${baseUrl}/onboard/${encodeURIComponent(advisorId)}`;
}
